@if (!isStandaloneMode()) {
  <np-header
    class="app-header"
    [sitename]="siteName"
    [welcomeMessage]="welcomeMessage()"
    [menuItems]="navigationItems()"
    [hasEnterpriseSearch]="false"
  ></np-header>
  <app-navigation [items]="navigationItems()"></app-navigation>

  <button class="logout" type="button" (click)="logout()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#0b2d71"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  </button>
}

<div class="app-shell">

  <main class="app-main">
    <app-notification-banner></app-notification-banner>

    <app-spinner></app-spinner>

    <router-outlet></router-outlet>
  </main>

</div>

@if (!isStandaloneMode()) {
  <np-footer
    [contentContactName]="'Contact Name'"
    [contentContactUrl]="'#'"
    [technicalContactName]="'Service Desk'"
    [technicalContactUrl]="'#'"
  >
  </np-footer>
}
